import {tns} from 'tiny-slider/src/tiny-slider'
import {haversine} from '../haversine'
import {openResurvaModal} from '../openResurvaModal'
import {replaceInString} from '../replaceInString'

const $window = $(window)

function initLocationSlideshow() {
	$('[data-styling-session]').once('initLocationSlideshow').each(function () {
		const $session = $(this)
		$session.removeClass('js-will-upgrade')

		const $search = $session.find('.styling-session__search')
		$search.removeClass('js-not-yet')

		const $locations = $session.find('.styling-session__locations')
		const slider = tns({
			container: $locations.get(0),
			controls: false,
			nav: false,
			loop: false,
			center: true,
			touch: true,
			mouseDrag: true,
			responsive: {
				600: {
					center: false
				}
			}
		})

		$session.data('tns', slider)
	})
}

function initLocationButtons() {
	const $location = $('.location').once('initLocationButtons')
	$location.on('click', function () {
		const embedCode = $(this).data('embedCode')
		openResurvaModal(embedCode)
	})
}

class LatLng {
	constructor(lat, lng) {
		this.lat = parseFloat(lat)
		this.lng = parseFloat(lng)
	}

	distanceFrom(anotherLatLng) {
		return parseFloat(haversine(this, anotherLatLng, 'mi'))
	}
}

function initStylingInvitation() {
	if ('geolocation' in navigator) {
		$('.styling-session').once('initStylingInvitation').each(function () {
			const $session = $(this)
			const ctaMessageTemplate = $session.data('ctaMessage')
			navigator.geolocation.getCurrentPosition(function ({coords, timestamp}) {
				const {latitude, longitude} = coords
				const userPosition = new LatLng(latitude, longitude)
				const myLocation =
					$session
						.find('.location')
						.toArray()
						.map(function (el) {
							const $location = $(el)
							const name = $location.data('name')
							const lat = $location.data('lat')
							const lng = $location.data('lng')
							const inviteDistance = $location.data('inviteDistance')
							const embedCode = $location.data('embedCode')

							const myPosition = new LatLng(lat, lng)
							const distance = userPosition.distanceFrom(myPosition)
							return {name, distance, inviteDistance, embedCode}
						})
						.filter(({distance, inviteDistance}) => {
							return distance <= inviteDistance
						})
						.sort((a, b) => {
							return a.distance <= b.distance
						})
						.shift()

				if (myLocation) {
					const message = replaceInString(ctaMessageTemplate, {
						city: myLocation.name
					})
					const action = 'stylingSession:openModal'
					$window.trigger('siteCta:setTemporaryMessage', {
						message,
						action
					})
					$window.on(action, function () {
						openResurvaModal(myLocation.embedCode)
					})
				}
			}, function () {
				// error
			})
		})
	}
}

export function initStylingSession() {
	// initLocationSlideshow()
	initLocationButtons()
	initStylingInvitation()
}